import modelYearTypes from 'commons-vehicle/ModelYear/actions/modelYearActionTypes.js';
import purchaseMethodsTypes from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActionTypes.js';
import ModelYearModel from 'commons-vehicle/ModelYear/models/ModelYearModel.js';
import ModelYearService from 'commons-vehicle/ModelYear/services/ModelYearService/ModelYearService.js';

export default function modelYearReducer(state = new ModelYearModel(), action) {
    switch (action.type) {
        case modelYearTypes.LOAD_MODEL_YEAR_SUCCESS:
            return action.modelYear;

        case modelYearTypes.SET_MODEL_YEARS:
            return state.set('year', action.modelYear.year).set('years', action.modelYear.years);

        case modelYearTypes.SET_MODEL_TRIMS:
            return state
                .set('modelTrims', action.modelYear.modelTrims)
                .set('drivePowerTrains', action.modelYear.drivePowerTrains)
                .set('optionsPackages', action.modelYear.optionsPackages);

        case modelYearTypes.SET_DRIVE_POWER_TRAINS:
            return state
                .set('drivePowerTrains', action.modelYear.drivePowerTrains)
                .set('optionsPackages', action.modelYear.optionsPackages);

        case modelYearTypes.SET_OPTIONS_PACKAGES:
            return state.set('optionsPackages', action.modelYear.optionsPackages);

        case purchaseMethodsTypes.SELECT_PURCHASE_METHOD:
            return ModelYearService.selectPurchaseMethod(state, action.purchaseMethod);

        case purchaseMethodsTypes.SELECT_TERM:
            return ModelYearService.selectTerm(state, parseInt(action.term, 10));

        case purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY:
            return ModelYearService.selectPaymentFrequency(state, action.paymentFrequency.value);

        case purchaseMethodsTypes.SELECT_KM_PLAN:
            return ModelYearService.selectKMPlan(state, action.kmPlan.value);

        case purchaseMethodsTypes.SET_CASH_DOWN:
            return ModelYearService.setCashDown(state, action.cashDown);

        case purchaseMethodsTypes.SET_TRADE_IN:
            return ModelYearService.setTradeIn(state, action.tradeIn);

        case purchaseMethodsTypes.SET_LIEN:
            return ModelYearService.setLien(state, action.lien);

        case purchaseMethodsTypes.SET_EXTERIOR_COLOUR_AMOUNTS:
            return ModelYearService.setExteriorColourAmounts(state, action.exteriorColourAmounts);

        case purchaseMethodsTypes.SET_INTERIOR_COLOUR_AMOUNTS:
            return ModelYearService.setInteriorColourAmounts(state, action.interiorColourAmounts);

        case purchaseMethodsTypes.SET_OPTIONS_AMOUNTS:
            return ModelYearService.setOptionsAmounts(state, action.optionsAmounts);

        case purchaseMethodsTypes.SET_TAXES_INCLUDED:
            return ModelYearService.setTaxesIncluded(state, action.taxesIncluded);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ModelYear/reducers/modelYearReducer.js